import '../payment-message-dialog.scss';

export default class FailureCtrl {

    // @ngInject
    constructor() {
    }

    next() {
        window.location.reload();
    }

}



// WEBPACK FOOTER //
// ./payments/failure/failure-ctrl.js